import { Dialog, Transition } from '@headlessui/react';
import React, { useState } from 'react';
import { Fragment } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';
import { toast } from 'react-toastify';
import { IconX, IconReload, IconAlertCircle } from '@tabler/icons-react';
import LoadingIndicator from '../../components/LoadingIndicator';

export default function RestoreBarang({
    isOpenModalRestore,
    closeModalRestore,
    reloadData,
    selectedIds
}) {

    const [loading, setLoading] = useState(false);
    const handleSubmitBarangRestore = async () => {
        if (!selectedIds || selectedIds.length === 0) {
            toast.error('Pastikan telah memilih barang yang akan direstore', { autoClose: 1000 });
            return;
        }

        setLoading(true);
        const data = { items: selectedIds };
        try {
            await http.post(`/trash/restore`, data, {
                headers: { Authorization: getAuthorizationHeader() },
            });
            toast.success('Data berhasil dipulihkan', { autoClose: 800 });
            closeModalRestore();
            reloadData();
        } catch (err) {
            if (err.response?.status === 400) {
                toast.error('Gagal memulihkan barang. Silakan coba lagi.', { autoClose: 1000 });
            }
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <LoadingIndicator />}
            <Transition appear show={isOpenModalRestore} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={closeModalRestore}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex items-center justify-center p-4 min-h-screen text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-slate-900 p-0 text-left align-middle shadow-2xl transition-all border dark:border-slate-800">
                                    {/* Header */}
                                    <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between bg-white dark:bg-slate-900">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-900/20 flex items-center justify-center text-amber-600 dark:text-amber-400">
                                                <IconReload className="w-6 h-6" />
                                            </div>
                                            <div>
                                                <Dialog.Title as="h3" className="text-lg font-bold text-slate-800 dark:text-slate-100">
                                                    Pulihkan Barang
                                                </Dialog.Title>
                                                <p className="text-xs text-slate-500 dark:text-slate-400">Restore ke list item</p>
                                            </div>
                                        </div>
                                        <button
                                            onClick={closeModalRestore}
                                            className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 dark:text-slate-500 transition-colors"
                                        >
                                            <IconX className="w-5 h-5" />
                                        </button>
                                    </div>

                                    {/* Body */}
                                    <div className="p-8 text-center bg-white dark:bg-slate-900">
                                        <div className="mb-4 w-14 h-14 rounded-full bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center mx-auto ring-4 ring-blue-50/50 dark:ring-blue-900/10">
                                            <IconAlertCircle className="w-7 h-7 text-blue-500 dark:text-blue-400" />
                                        </div>
                                        <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed max-w-[260px] mx-auto">
                                            Apakah Anda yakin ingin memulihkan <span className="font-bold text-blue-600 dark:text-blue-400">{selectedIds?.length} barang</span> yang dipilih kembali ke list item?
                                        </p>
                                    </div>

                                    {/* Footer */}
                                    <div className="px-6 py-4 bg-slate-50/50 dark:bg-slate-800/20 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row gap-3">
                                        <button
                                            type="button"
                                            disabled={loading}
                                            onClick={closeModalRestore}
                                            className="flex-1 h-11 inline-flex items-center justify-center rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors disabled:opacity-50 shadow-sm"
                                        >
                                            Batal
                                        </button>
                                        <button
                                            type="button"
                                            disabled={loading}
                                            onClick={handleSubmitBarangRestore}
                                            className="flex-1 h-11 inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 text-white font-bold hover:from-amber-400 hover:to-amber-500 shadow-lg shadow-amber-600/20 active:scale-[0.98] transition-all disabled:opacity-50 disabled:from-slate-400 disabled:to-slate-400"
                                        >
                                            {loading ? (
                                                <div className="w-5 h-5 rounded-full border-2 border-white/30 border-t-white animate-spin"></div>
                                            ) : (
                                                <>
                                                    <IconReload className="w-5 h-5" />
                                                    <span>Pulihkan Sekarang</span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
